import React, {useEffect, useState} from "react";
import {User} from "../../models/user";
import {MDBBadge, MDBTable, MDBTableBody, MDBTableHead} from "mdb-react-ui-kit";
import {useNavigate} from "react-router-dom";
import {ERR_BAD_REQUEST, getData} from "../../network/network";
import {AxiosError} from "axios";

export const RegisteredAccounts = () => {
    const [data, setData] = useState<User[]>([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')

    const navigate = useNavigate()
    useEffect(() => {
        setLoading(true)
        getData({
            url: '/api/users/fetchAll',
            onSuccess: (list: User[]) => {
                setData(list)
                setLoading(false)
            },
            onError: (err: AxiosError) => {
                switch (err.code) {
                    case ERR_BAD_REQUEST:
                        setError(`${err?.response?.data}`)
                        break
                    default:
                        setError("service unavailable")
                }
                setLoading(false)
            }
        }, navigate)
    }, []);

    if (loading) {
        return (<div className="container mt-4">
                <div className="row justify-content-center align-items-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        )
    }

    if (error.length > 0) {
        return (<div className="container mt-4">
                <div className="row justify-content-center align-items-center">
                    {error}
                </div>
            </div>
        )
    }

    if (data.length === 0) {
        return (<div className="container mt-4">
                <div className="row justify-content-center align-items-center">
                    No data available
                </div>
            </div>
        )
    }
    return (
        <div className="container mt-4">
            <MDBTable align='middle' striped hover>
                <MDBTableHead>
                    <tr>
                        <th scope='col'>Name</th>
                        <th scope='col'>Email</th>
                        <th scope='col'>Type</th>
                        <th scope='col'>Company</th>
                        <th scope='col'>Phone</th>
                        <th scope='col'>Status</th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody>
                    {data.map((item: User) => {
                        return (
                            <tr onClick={() => {
                                navigate(`/home/createAccount?data=${btoa(JSON.stringify(item))}`)
                            }}>
                                <td>
                                    <div className='d-flex align-items-center'>
                                        <div className='ms-3'>
                                            <p className='fw-bold mb-1'>{item.username}</p>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <p className='fw-normal mb-1'>{item.email}</p>
                                </td>
                                <td>
                                    {item.user_type === 1 ?
                                        <MDBBadge color='warning' pill>
                                            Admin
                                        </MDBBadge> : <MDBBadge color='success' pill>
                                            Normal
                                        </MDBBadge>}
                                </td>
                                <td>
                                    <p className='fw-normal mb-1'>{item.company}</p>
                                </td>
                                <td>
                                    <p className='fw-normal mb-1'>{item.mobile}</p>
                                </td>
                                <td>{item.status === 'active' ?
                                    <MDBBadge color='info' pill>
                                        Active
                                    </MDBBadge> : <MDBBadge color='danger' pill>
                                        Inactive
                                    </MDBBadge>}</td>
                            </tr>
                        )
                    })}
                </MDBTableBody>
            </MDBTable>
        </div>
    )
}